import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Production security hardening:
 * - Disables right-click context menu (prevents easy "View Source" / "Inspect")
 * - Disables common DevTools keyboard shortcuts
 * - Clears console periodically to prevent credential harvesting from logs
 *
 * Note: This deters casual users, not determined attackers.
 * Real security is always server-side.
 */
@Injectable({
  providedIn: 'root'
})
export class DevtoolsGuardService {

  private isActive = false;

  /**
   * Call once from AppComponent to activate production guards.
   * Only activates in production mode.
   */
  activate(): void {
    if (!environment.production || this.isActive) return;
    this.isActive = true;

    // Disable right-click context menu
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
      return false;
    });

    // Disable common DevTools shortcuts
    document.addEventListener('keydown', (e) => {
      // F12
      if (e.key === 'F12') {
        e.preventDefault();
        return;
      }
      // Ctrl+Shift+I (Inspect), Ctrl+Shift+J (Console), Ctrl+Shift+C (Element picker)
      if (e.ctrlKey && e.shiftKey && ['I', 'i', 'J', 'j', 'C', 'c'].includes(e.key)) {
        e.preventDefault();
        return;
      }
      // Ctrl+U (View Source)
      if (e.ctrlKey && (e.key === 'U' || e.key === 'u')) {
        e.preventDefault();
        return;
      }
    });

    // Clear console periodically to prevent credential leakage from debug logs
    this.clearConsolePeriodically();

    // Override console methods in production to suppress all output
    this.suppressConsoleOutput();
  }

  private clearConsolePeriodically(): void {
    setInterval(() => {
      console.clear();
    }, 30000); // Every 30 seconds
  }

  private suppressConsoleOutput(): void {
    // Suppress all console output in production
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
    console.warn = noop;
    // Keep console.error for critical issues
  }
}
